<template>
  <hic-list-page title="报表管理" :entities="entities" :condition="condition" @load="page" :loading="searchLoading" keyword-placeholder="请输入名称或编码" row-key="code" lazy :lazy-load="queryChildren" :search-fields="searchFields">
    <template slot="buttons">
      <el-dropdown v-if="permission.masterdata_report_edit" split-button size="small" type="primary" @click="create()" @command="cmdHandel">
        <i class="el-icon-plus"></i> 新建
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="db">数据库连接</el-dropdown-item>
          <el-dropdown-item command="rpt">配置中心报表展示</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <el-table-column label="名称" prop="name" fixed="left">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="view(row)">
          <b>{{ row.name }}</b>
        </el-link>
      </template>
    </el-table-column>
    <el-table-column v-if="permission.masterdata_report_edit" label="操作" fixed="left" width="180" align="center">
      <template slot-scope="{ row }">
        <el-button v-if="permission.masterdata_report_edit && row.id" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(row)" title="编辑" />
        <hic-regret-button v-if="permission.masterdata_report_edit && row.id" type="danger" icon="el-icon-delete" circle plain @click="del(row)" :seconds="5" size="mini" badge="success" :disabled="!row.id" class="left-pad"></hic-regret-button>
        <el-tag v-if="!row.id" size="mini" type="info">已删除</el-tag>
        <el-button v-if="permission.masterdata_report_edit && row.id" type="success" icon="el-icon-plus" circle plain size="mini" class="left-pad" @click="create(row)" :disabled="!!row.parentId" />
        <el-button v-if="permission.masterdata_report_edit && row.id" type="warning" icon="el-icon-files" circle plain size="mini" @click="copy(row)" title="拷贝" />
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" align="left"></el-table-column>
    <el-table-column label="应用" prop="sys" :filters="dict.Sys" :filter-multiple="false" column-key="sys" align="center">
      <template #default="{ row }">
        {{ row.sys | dictText("Sys") }}
      </template>
    </el-table-column>
    <el-table-column label="类型" prop="type" :filters="dictEnum.ReportType" :filter-multiple="false" column-key="type" align="center">
      <template #default="{ row }">
        {{ row.type }}
      </template>
    </el-table-column>
    <el-table-column label="停用" prop="disabled" width="60" align="center">
      <template slot-scope="scope">
        <el-tag v-if="scope.row.disabled" type="danger" size="mini" effect="plain">是</el-tag>
        <el-tag v-else type="success" size="mini" effect="plain">否</el-tag>
      </template>
    </el-table-column>
    <EditDlg :visible.sync="showEditor" v-model="entity" :parent="parent" @saved="saved" />
    <InfoDlg :visible.sync="showInfo" v-model="entityInfo" />
    <DbDlg :visible.sync="showDb" />
  </hic-list-page>
</template>
<script>
  import api from "./api";
  import store from "@/common/store";
  import { mapGetters } from "sw-hic";
  // import cfg from "@/common/cfg"
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.masterdata_report_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    components: {
      EditDlg: () => import("./edit"),
      InfoDlg: () => import("./info"),
      DbDlg: () => import("./dbDlg"),
    },
    data() {
      return {
        searchLoading: false,
        showEditor: false,
        showInfo: false,
        showDb: false,
        entities: {},
        entity: {},
        entityInfo: null,
        condition: {
          keyword: null,
          nulls: "parentId",
          sort: "id",
          asc: false,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        editOrigin: null,
        parent: null,
        maps: new Map(),
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "permission"]),
      searchFields() {
        return [
          { label: "名称", prop: "name", type: "input" },
          { label: "编码", prop: "code", type: "input" },
          { label: "应用", prop: "sys", type: "dict", options: this.dict.Sys },
          { label: "类型", prop: "type", type: "dict", options: this.dictEnum.ReportType },
          { label: "停用", prop: "disabled", type: "dict", options: this.$utils.Dict.bool() },
        ];
      },
    },
    methods: {
      page() {
        this.searchLoading = true;
        if (this.condition.keyword) {
          this.condition.nulls = null;
        } else {
          this.condition.nulls = "parentId";
        }
        api.Report.query(this.condition).then((res) => {
          res.items.forEach((i) => {
            i.hasChildren = true;
          });
          this.entities = res;
          this.searchLoading = false;
        });
      },
      create(parent) {
        this.editOrigin = null;
        this.entity = { id: null, parentId: parent ? parent.id : null, sys: parent ? parent.sys : null, type: parent ? parent.type : null, dbConCode: parent ? parent.dbConCode : null, disabled: false };
        this.parent = parent;
        this.showEditor = true;
      },
      edit(row) {
        this.parent = null;
        this.editOrigin = row;
        this.entity = this.$utils.Obj.clone(row);
        this.showEditor = true;
      },
      copy(row) {
        this.editOrigin = null;
        this.entity = this.$utils.Obj.clone(row);
        this.entity.id = null;
        this.entity.lockKey = null;
        this.entity.disabled = false;
        this.entity.name = this.entity.name + "_副本";
        this.entity.code = this.entity.code + "_Copy";
        this.showEditor = true;
      },
      view(row) {
        this.entityInfo = row;
        this.showInfo = true;
      },
      saved(newEntity) {
        if (newEntity.parentId) {
          this.reQueryChildren(newEntity.parentId);
        } else {
          this.page();
        }
      },
      del(row) {
        api.Report.del(row.id).then(() => {
          row.id = null;
        });
      },
      queryChildren(row, node, resolve) {
        this.maps.set(row.id, { row, node, resolve });
        api.Report.query({ parentId: row.id }).then((res) => {
          resolve(res.items);
        });
      },
      reQueryChildren(id) {
        let parent = this.maps.get(id);
        if (parent) {
          this.queryChildren(parent.row, parent.node, parent.resolve);
        }
      },
      cmdHandel(cmd) {
        switch (cmd) {
          case "db":
            this.showDb = true;
            break;
          case "rpt":
            this.$router.push("/reportIndex");
          default:
            break;
        }
      },
    },
  };
</script>
